module.exports = __webpack_public_path__ + "assets/img/my-car.31791ae6.jpg";